// eslint-disable-next-line @typescript-eslint/no-explicit-any
import { createClient, type SupabaseClient } from '@supabase/supabase-js';

export interface SupabaseConfig {
  url: string;
  anonKey: string;
}

// Cliente nao-tipado por enquanto. Ate gerar types via `npm run supabase:gen-types`,
// usamos `any` para nao bloquear desenvolvimento.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function createSupabaseClient(config: SupabaseConfig): SupabaseClient<any, any, any> {
  if (!config.url || !config.anonKey) {
    throw new Error('Supabase URL e anonKey sao obrigatorios');
  }

  return createClient(config.url, config.anonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function createSupabaseAdminClient(url: string, serviceRoleKey: string): SupabaseClient<any, any, any> {
  if (!url || !serviceRoleKey) {
    throw new Error('Supabase URL e serviceRoleKey sao obrigatorios');
  }

  return createClient(url, serviceRoleKey, {
    auth: {
      persistSession: false,
      autoRefreshToken: false,
    },
  });
}
